import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const fd = new FormData();
export default class UpdateAlumini extends Component {
  state = {
    message: "",
    notification: false,
    per_pge: 20,
    page_no: 1,
    client_image: {},
    client_name: "",
    testimonial: "",
    links: "",
    testimonial_from: "",
    highlights: "",
    achievements: "",
    description: "",
  };

  componentDidMount() {
    this.getsingleAlumini();
  }

  getsingleAlumini = async () => {
    if (init() === "success") {
      await axios
        .get(Constants.getUrls.getAllAlumini + "/" + window.location.pathname.split("/")[2])
        .then((resp) => {
          console.log(resp);

          this.setState({
            // client_image: resp.data.data.image,
            client_name: resp.data.data.name,
            highlights: resp.data.data.highlights,
            achievements: resp.data.data.achivements,
            description: resp.data.data.content,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleDescription = (e) => {
    // console.log(e);
    this.setState({ description: e });
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    fd.append("name", this.state.client_name);
    fd.append("client_image", this.state.client_image);
    fd.append("content", this.state.description);
    fd.append("highlights", this.state.highlights);
    fd.append("achivements", this.state.achievements);
    // return;
    if (init() === "success") {
      axios
        .put(Constants.putUrls.updateAlumini + window.location.pathname.split("/")[2], fd)
        .then((resp) => {
          // console.log(resp);
          fd.delete("image");
          this.setState({
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/alumini" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Update Alumini
                    </MDTypography>
                  </MDBox>
                  {/* <Grid item sm={4} px={2} align="right">
                    <Link to="/admin/addNewJob">
                      <MDButton variant="contained" size="small" color="primary">
                        Create Job
                      </MDButton>
                    </Link>
                  </Grid> */}
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Alumini Name"
                            name="client_name"
                            value={this.state.client_name}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Alumini Achievements"
                            name="achievements"
                            value={this.state.achievements}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Alumini Highlights"
                            name="highlights"
                            value={this.state.highlights}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Alumini Image"
                            name="client_image"
                            focused
                            onChange={(e) => {
                              this.setState({
                                client_image: e.target.files[0],
                              });
                            }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={12}>
                          <SunEditor
                            // width="120%"
                            setDefaultStyle="font-family: Arial; font-size: 16px;"
                            setOptions={{
                              buttonList: [
                                ["undo", "redo"],
                                ["font", "fontSize"],
                                ["paragraphStyle", "blockquote"],
                                [
                                  "bold",
                                  "underline",
                                  "italic",
                                  "strike",
                                  "subscript",
                                  "superscript",
                                ],
                                ["fontColor", "hiliteColor"],
                                ["align", "list", "lineHeight"],
                                ["outdent", "indent"],

                                ["table", "horizontalRule", "link", "image", "video"],
                                // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                                ["imageGallery"], // You must add the "imageGalleryUrl".
                                // ["fullScreen", "showBlocks", "codeView"],
                                ["preview", "print"],
                                ["removeFormat"],

                                // ["save", "template"],
                                // '/', Line break
                              ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                              defaultTag: "div",
                              height: 120,
                              showPathLabel: false,
                              // font: sortedFontOptions
                            }}
                            name="description"
                            setContents={this.state.description}
                            onChange={this.handleDescription}
                          />
                        </Grid>
                      </Grid>

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Updating..." : "Update"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="VASA Alumini"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
